export default __webpack_public_path__ + "static/media/fil.f25f4794.png";